import { useMutation, useQuery } from 'react-query'
import useCacheKeys from '../use-cache-keys'
import useCache from '../use-cache'
import useApi from '../use-api'
import { useCallback, useState } from 'react'

const useUserMutations = ({
    userId,
    onSuccess = () => {},
    onError = () => {},
}) => {
    const [ user, setUser ] = useState({})
    const cacheKeys = useCacheKeys()
    const { clearCache } = useCache({ key: cacheKeys.USERS, onReload: onSuccess })
    const { api, url, endpoints } = useApi()

    const { isLoading } = useQuery(
        [ cacheKeys.USERS, userId ],
        () => api.get(url(endpoints.user, { userId })),
        {
            enabled: userId,
            onSuccess: setUser,
        }
    )

    const [ updateUser, { isLoading: isUpdating }] = useMutation(
        ({
            id,
            firstName,
            lastName,
            email,
            rolesCode,
            studentId,
            gradYear,
        }) => api.put(url(endpoints.user, { userId: id }), {
            firstName,
            lastName,
            email,
            rolesCode,
            studentId,
            gradYear,
        }),
        {
            onSuccess: clearCache,
            onError,
        }
    )

    const [ deleteUser, { isLoading: isDeleting }] = useMutation(
        overrideId => api.delete(url(endpoints.user, { userId: overrideId || userId })),
        {
            onSuccess: clearCache,
            onError,
        }
    )

    const saveUser = useCallback( userOverride => {
        const targetUser = userOverride || user
        if (targetUser.id) {
            updateUser(targetUser)
        }
    }, [])

    return {
        isLoading,
        user,
        setUser,
        deleteUser,
        isDeleting,
        saveUser,
        isSaving: isUpdating,
    }
}

export default useUserMutations